import React from 'react';
import styles from './FixedFooter.less';

class FixedFooter extends React.Component {
	render() {
		const {className, ...props} = this.props;
		const {fixedFooter: fixedFooterClass} = styles;
		const classes = [fixedFooterClass];

		if (className) {
			classes.push(className);
		}

		return (
			<div className={classes.join(' ')} {...props} />
		)
	}
}

export default FixedFooter;